import { useQuery } from '@tanstack/react-query'
import { useLocation, useParams } from '@tanstack/react-router'
import { useQuoteBuilderApi } from '../api/client'
import { quoteQueryOptions } from '../api/queries'
import { isSmartQuotePath } from '../assistant/panel-store'
import { QuoteAssistant } from '../assistant/quote-assistant'

/**
 * Where the quote assistant mounts: once, in the dashboard layout, as the demo mounts it in its
 * app shell. On a `/quotes/$quoteId/*` page the assistant works on that quote. Outside the Quotes
 * section it is hidden but stays mounted, so a conversation survives a trip to another page.
 */
export function QuoteAssistantMount() {
  const api = useQuoteBuilderApi()
  const { pathname } = useLocation()
  const { quoteId } = useParams({ strict: false }) as { quoteId?: string }
  const quote = useQuery({ ...quoteQueryOptions(api, quoteId ?? ''), enabled: Boolean(quoteId) })
  return (
    <div hidden={!isSmartQuotePath(pathname)}>
      <QuoteAssistant quote={quoteId ? (quote.data ?? null) : null} quoteId={quoteId ?? null} />
    </div>
  )
}
